export enum RequoteClaimProgressEnum {
  CancelingItems = 1,
  CreatingNewQuote = 2,
  SelectingSuppliers = 3,
  Finished = 4,
  Error = 5
}

